import { render, staticRenderFns } from "./CardDeInformacoesDoProduto.vue?vue&type=template&id=1fc5c110&scoped=true&"
import script from "./CardDeInformacoesDoProduto.vue?vue&type=script&lang=ts&"
export * from "./CardDeInformacoesDoProduto.vue?vue&type=script&lang=ts&"
import style0 from "./CardDeInformacoesDoProduto.vue?vue&type=style&index=0&id=1fc5c110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc5c110",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VDivider,VIcon,VImg,VRow})
